// extracted by mini-css-extract-plugin
export default {"searchLabel":"Search_searchLabel__8V8Hs","controllers":"Search_controllers__rrcTM"};